/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_TitleInputs */

const id_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis Klien egdata.app`)
};

const ms_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran Klien egdata.app`)
};

const da_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Klientudgivelser`)
};

const de_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Client-Veröffentlichungen`)
};

const en_us2_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Client Releases`)
};

const es_es2_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos del cliente egdata.app`)
};

const es_mx2_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos del cliente egdata.app`)
};

const fil_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Release ng egdata.app Client`)
};

const fr_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions du client egdata.app`)
};

const it_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioni client egdata.app`)
};

const hu_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app kliens kiadások`)
};

const nl_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Client Releases`)
};

const no_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Client-utgivelser`)
};

const pl_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydania klienta egdata.app`)
};

const pt_br2_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versões do cliente egdata.app`)
};

const pt_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos do cliente egdata.app`)
};

const ro_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansări client egdata.app`)
};

const fi_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app-asiakasohjelman julkaisut`)
};

const sv_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app-klientrelease`)
};

const vi_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản phát hành ứng dụng egdata.app`)
};

const tr_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app İstemci Sürümleri`)
};

const cs_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydání klienta egdata.app`)
};

const bg_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издания на клиента egdata.app`)
};

const ru_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Релизы клиента egdata.app`)
};

const uk_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Релізи клієнта egdata.app`)
};

const ar_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصدارات عميل egdata.app`)
};

const hi_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app क्लाइंट रिलीज़`)
};

const th_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวางจำหน่ายไคลเอนต์ egdata.app`)
};

const ja_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app クライアントリリース`)
};

const zh_cn2_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 客户端版本`)
};

const zh_hant1_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 用戶端版本`)
};

const ko_misc_downloads_title = /** @type {(inputs: Misc_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 클라이언트 릴리스`)
};

/**
* | output |
* | --- |
* | "egdata.app Client Releases" |
*
* @param {Misc_Downloads_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_title = /** @type {((inputs?: Misc_Downloads_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_title(inputs)
	if (locale === "ms") return ms_misc_downloads_title(inputs)
	if (locale === "da") return da_misc_downloads_title(inputs)
	if (locale === "de") return de_misc_downloads_title(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_title(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_title(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_title(inputs)
	if (locale === "fil") return fil_misc_downloads_title(inputs)
	if (locale === "fr") return fr_misc_downloads_title(inputs)
	if (locale === "it") return it_misc_downloads_title(inputs)
	if (locale === "hu") return hu_misc_downloads_title(inputs)
	if (locale === "nl") return nl_misc_downloads_title(inputs)
	if (locale === "no") return no_misc_downloads_title(inputs)
	if (locale === "pl") return pl_misc_downloads_title(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_title(inputs)
	if (locale === "pt") return pt_misc_downloads_title(inputs)
	if (locale === "ro") return ro_misc_downloads_title(inputs)
	if (locale === "fi") return fi_misc_downloads_title(inputs)
	if (locale === "sv") return sv_misc_downloads_title(inputs)
	if (locale === "vi") return vi_misc_downloads_title(inputs)
	if (locale === "tr") return tr_misc_downloads_title(inputs)
	if (locale === "cs") return cs_misc_downloads_title(inputs)
	if (locale === "bg") return bg_misc_downloads_title(inputs)
	if (locale === "ru") return ru_misc_downloads_title(inputs)
	if (locale === "uk") return uk_misc_downloads_title(inputs)
	if (locale === "ar") return ar_misc_downloads_title(inputs)
	if (locale === "hi") return hi_misc_downloads_title(inputs)
	if (locale === "th") return th_misc_downloads_title(inputs)
	if (locale === "ja") return ja_misc_downloads_title(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_title(inputs)
	return ko_misc_downloads_title(inputs)
});
export { misc_downloads_title as "misc.downloads.title" }